import type { SelectOption } from '../ui/plain-select.ts';

/** Display labels only: choosing a unit does not convert the plotted value. */
export const UNIT_OPTIONS: SelectOption[] = [
  { value: '', label: 'No unit' },
  { value: '%', label: '% · Percent', keywords: 'percentage ratio' },
  { value: 'W', label: 'W · Watts', keywords: 'power' },
  { value: 'kW', label: 'kW · Kilowatts', keywords: 'power' },
  { value: 'MW', label: 'MW · Megawatts', keywords: 'power' },
  { value: 'kWh', label: 'kWh · Kilowatt-hours', keywords: 'energy' },
  { value: 'MWh', label: 'MWh · Megawatt-hours', keywords: 'energy' },
  { value: 'GJ', label: 'GJ · Gigajoules', keywords: 'energy' },
  { value: 'kg', label: 'kg · Kilograms', keywords: 'mass weight fuel' },
  { value: 't', label: 't · Tonnes', keywords: 'mass weight fuel' },
  { value: 'kg/h', label: 'kg/h · Kilograms per hour', keywords: 'mass flow fuel consumption rate' },
  { value: 't/h', label: 't/h · Tonnes per hour', keywords: 'mass flow fuel consumption rate' },
  { value: 't/d', label: 't/d · Tonnes per day', keywords: 'mass flow fuel consumption rate' },
  { value: 'g/kWh', label: 'g/kWh · Grams per kilowatt-hour', keywords: 'specific fuel consumption sfoc' },
  { value: 't/nm', label: 't/nm · Tonnes per nautical mile', keywords: 'fuel distance consumption' },
  { value: 'kg/nm', label: 'kg/nm · Kilograms per nautical mile', keywords: 'fuel distance consumption' },
  { value: 'L', label: 'L · Litres', keywords: 'volume' },
  { value: 'm³', label: 'm³ · Cubic metres', keywords: 'volume m3' },
  { value: 'L/h', label: 'L/h · Litres per hour', keywords: 'volume flow rate' },
  { value: 'm³/h', label: 'm³/h · Cubic metres per hour', keywords: 'volume flow rate m3/h' },
  { value: 'kn', label: 'kn · Knots', keywords: 'speed knots' },
  { value: 'km/h', label: 'km/h · Kilometres per hour', keywords: 'speed' },
  { value: 'm/s', label: 'm/s · Metres per second', keywords: 'speed' },
  { value: 'nm', label: 'nm · Nautical miles', keywords: 'distance nautical mile' },
  { value: 'km', label: 'km · Kilometres', keywords: 'distance length' },
  { value: 'm', label: 'm · Metres', keywords: 'distance length draft' },
  { value: 'rpm', label: 'rpm · Revolutions per minute', keywords: 'rotation engine speed' },
  { value: '°C', label: '°C · Degrees Celsius', keywords: 'temperature' },
  { value: '°F', label: '°F · Degrees Fahrenheit', keywords: 'temperature' },
  { value: 'K', label: 'K · Kelvin', keywords: 'temperature' },
  { value: 'bar', label: 'bar · Bar', keywords: 'pressure' },
  { value: 'kPa', label: 'kPa · Kilopascals', keywords: 'pressure' },
  { value: 'MPa', label: 'MPa · Megapascals', keywords: 'pressure' },
  { value: 'Hz', label: 'Hz · Hertz', keywords: 'frequency' },
  { value: 'V', label: 'V · Volts', keywords: 'voltage electric' },
  { value: 'A', label: 'A · Amperes', keywords: 'current electric' },
  { value: 's', label: 's · Seconds', keywords: 'time duration' },
  { value: 'min', label: 'min · Minutes', keywords: 'time duration' },
  { value: 'h', label: 'h · Hours', keywords: 'time duration' },
  { value: 'd', label: 'd · Days', keywords: 'time duration' },
  { value: 'ppm', label: 'ppm · Parts per million', keywords: 'concentration' },
  { value: 'tCO₂', label: 'tCO₂ · Tonnes of CO₂', keywords: 'emissions carbon dioxide co2' },
  { value: 'tCO₂/h', label: 'tCO₂/h · Tonnes of CO₂ per hour', keywords: 'emissions carbon dioxide co2 rate' },
];

export function isPresetUnit(value: string): boolean {
  return UNIT_OPTIONS.some((option) => option.value === value);
}
